<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
    width?: string;
  }>(),
  {
    color: getCSSVar("--yz-xg-blue", "#5a82f0"),
    width: "0.8em"
  }
);
</script>

<template>
  <div
    class="loading-11"
    ref="loading11"
  >
    <div
      class="loading-11-inner"
      :style="{ width: props.width, height: props.width }"
    >
      <div class="container container-1">
        <div
          class="dot dot-1"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-2"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-3"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-4"
          :style="{ backgroundColor: props.color }"
        ></div>
      </div>
      <div class="container container-2">
        <div
          class="dot dot-1"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-2"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-3"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-4"
          :style="{ backgroundColor: props.color }"
        ></div>
      </div>
      <div class="container container-3">
        <div
          class="dot dot-1"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-2"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-3"
          :style="{ backgroundColor: props.color }"
        ></div>
        <div
          class="dot dot-4"
          :style="{ backgroundColor: props.color }"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.loading-11 {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loading-11-inner {
  position: relative;
}
.loading-11-inner .container {
  position: absolute;
  width: 100%;
  height: 100%;
}
.loading-11-inner .container .dot {
  width: 20%;
  height: 20%;
  border-radius: 100%;
  position: absolute;
  animation: bouncedelay 1.2s infinite ease-in-out;
  animation-fill-mode: both;
}
.loading-11-inner .container .dot-1 {
  top: 0;
  left: 0;
}
.loading-11-inner .container .dot-2 {
  top: 0;
  right: 0;
}
.loading-11-inner .container .dot-3 {
  right: 0;
  bottom: 0;
}
.loading-11-inner .container .dot-4 {
  left: 0;
  bottom: 0;
}
.loading-11-inner .container-1 .dot-2 {
  animation-delay: -0.9s;
}
.loading-11-inner .container-1 .dot-3 {
  animation-delay: -0.6s;
}
.loading-11-inner .container-1 .dot-4 {
  animation-delay: -0.3s;
}
.loading-11-inner .container-2 {
  transform: rotateZ(45deg);
}
.loading-11-inner .container-2 .dot-1 {
  animation-delay: -1.1s;
}
.loading-11-inner .container-2 .dot-2 {
  animation-delay: -0.8s;
}
.loading-11-inner .container-2 .dot-3 {
  animation-delay: -0.5s;
}
.loading-11-inner .container-2 .dot-4 {
  animation-delay: -0.2s;
}
.loading-11-inner .container-3 {
  transform: rotateZ(90deg);
}
.loading-11-inner .container-3 .dot-1 {
  animation-delay: -1s;
}
.loading-11-inner .container-3 .dot-2 {
  animation-delay: -0.7s;
}
.loading-11-inner .container-3 .dot-3 {
  animation-delay: -0.4s;
}
.loading-11-inner .container-3 .dot-4 {
  animation-delay: -0.1s;
}
@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0.3);
  }
  40% {
    transform: scale(1);
  }
}
</style>
